<template>
	<div class="verification-tool">
		<h2>Infrastructure Test</h2>

		<button @click="fetchUsers" :disabled="planningStore.initial" class="fetch-btn">
			{{ planningStore.initial ? 'Fetching 500+ Users...' : 'Load Users from API' }}
		</button>

		<hr />

		<div v-if="userStore.allUsers.length > 0" class="results">
			<h3>User List ({{ userStore.allUsers.length }}):</h3>
			<ul>
				<li v-for="user in userStore.allUsers" :key="user.id">
					{{ getFullName(user) }}
				</li>
			</ul>
		</div>

		<div v-else-if="!planningStore.initial" class="empty-state">No users loaded yet. Click the button to test the flow.</div>
	</div>
</template>

<script setup lang="ts">
// TODO: [Renovation-Phase-1] Remove this verification tool once real components are integrated.
// This is not part of the final production UX.

import { useUserStore } from '@/rennovation/planning-view/store/useUserStore';
import { usePlanningStore } from '@/rennovation/planning-view/store/usePlanningStore';
import { ApiBaseUser } from '@/rennovation/planning-view/types/api/users-response';

// ============================================
// STORES
// ============================================
const userStore = useUserStore();
const planningStore = usePlanningStore();

// ============================================
// BUSINESS LOGIC
// ============================================
const getFullName = (user: ApiBaseUser): string => {
	return user.displayName || `${user.firstName} ${user.lastName}`;
};

const fetchUsers = async () => {
	await planningStore.initPlanningView();
};
</script>

<style scoped>
.fetch-btn {
	padding: 10px 20px;
	background-color: #42b983;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}

.fetch-btn:disabled {
	background-color: #ccc;
}

.results {
	margin-top: 20px;
	text-align: left;
}
</style>
